import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import './profileTab.scss';
const ProfileTab = ({ ...rest }) => {
  const {
    tabName,
    message: {
      title,
      comment,
      isCommentLocalization,
      isTitleLocalization = true,
      commentLink = false,
    },
    svgIcon,
    link,
    containerClass,
    handleTabClick,
    selectedTab,
    key,
    tabClassName,
    textColor,
  } = rest;
  const MainProfileTab = ({ left, right }) => (
    <div
      key={key}
      className={` ${containerClass} w-100 h-100 d-flex justify-content-center align-items-center`}
    >
      <div
        onClick={() => handleTabClick(tabName)}
        className={` d-flex align-items-center justify-content-start p-sm-3 py-3 px-2 w-100 cursor-pointer h-100 col-11 default-border-top-radius-small default-border-bottom-radius-small ${tabClassName} ${
          selectedTab === tabName
            ? `profile-tab-container-click bg-secondary  ${
                textColor ?? 'text-white'
              } glass`
            : `bg-primary ${textColor ?? 'text-third'}`
        } 
        `}
      >
        {left}
        {right}
      </div>
    </div>
  );

  const TabIconContainer = (planeIcone) => {
    return (
      <div className=" px-0">
        <div className={`icon-container p-sm-0 p-0 d-none d-xs-flex`}>
          {svgIcon}
        </div>
      </div>
    );
  };
  const TabTextContainer = () => {
    return (
      <div className="col-8 px-0 mx-sm-2 mx-1">
        <div className="w-100 text-truncate text-start d-flex flex-column px-xl-2 px-md-1 px-sm-1 px-xs-1 px-0 mx-0">
          <span className="w-100 text-truncate font-xl-normal font-sm-msmall font-smaller text-nowrap">
            {isTitleLocalization ? <FormattedMessage id={title} /> : title}
          </span>
          {commentLink === true ? (
            <>
              <span className={`font-xl-msmall font-xsmall text-nowrap`}>
                <Link
                  to={link}
                  className={`text-nowrap ${
                    selectedTab === tabName ? 'text-white' : 'text-third'
                  }`}
                >
                  {isCommentLocalization ? (
                    <>
                      <span className="comment-link">
                        <FormattedMessage id={comment} />
                      </span>
                      <sup>+</sup>
                    </>
                  ) : (
                    comment
                  )}
                </Link>
              </span>
            </>
          ) : (
            <>
              <span className="w-100 d-flex font-xl-msmall font-sm-smaller font-xsmall text-nowrap">
                {isCommentLocalization ? (
                  <span className="w-100 text-truncate">
                    <FormattedMessage id={comment} />
                  </span>
                ) : (
                  comment
                )}
              </span>
            </>
          )}
        </div>
      </div>
    );
  };
  return (
    <MainProfileTab left={<TabIconContainer />} right={<TabTextContainer />} />
  );
};
export default ProfileTab;
